import AdvisersSearchResultsHtml from '../../app-lite/advisers/templates/advisers.search.results.html';
import ProductSearchResultsHtml  from '../../app-lite/products/templates/product.search.results.html';

export function InspectionSettingsCtrl (
  $stateParams,
  $translate,
  messages,
  workshopAPI,
  settings
) {
  var vm = this;

  vm.settings = settings;

  vm.productSearch = {
    value: {
      id: settings.default_product_id,
      item_code: settings.item_code
    },
    templateUrl: ProductSearchResultsHtml,
    query: function (value) {
      return workshopAPI.get('/products/product_labor_list', [ value, 0, 5 ]);
    },
    select: function (product) {
      vm.settings.item_code = product.item_code;
      vm.settings.default_product_id = product.id;
    },
    format: function (product) {
      return product.item_code;
    }
  };

  vm.save = function () {
    workshopAPI.patch('/inspection_setting', vm.settings).then(function () {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.INSPECTION_SETTINGS'), 'success');
    }, function (err) {
      messages.error(err);
    });
  };

  vm.serviceAdviserSearch = {
    templateUrl: AdvisersSearchResultsHtml,
    list: [],
    value: {
      display_name: settings.service_adviser_display_name,
      id: settings.default_service_adviser_id
    },
    query: function (value) {
      return workshopAPI.get('/service_advisers/list', [ value, 0, '*' ]);
    },
    select: function (adviser) {
      vm.settings.default_service_adviser_id = adviser.id;
      vm.settings.service_adviser_display_name = adviser.display_name;
    },
    format: function (adviser) {
      return adviser.display_name || adviser.service_adviser_display_name;
    }
  };

  $stateParams.activated ? messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {name:"Inspections"}), 'success'): null;
};